import React from 'react';
import './loader.css';
import { Placeholder } from 'react-bootstrap';

const SkeletonParagraph = ({ lines = 3 }) => {
    function getRandomNumbe() {
        return Math.floor(Math.random() * 6) + 5;
    }
    return (
        <div className="skeleton-paragraph">
            <h2>
                <Placeholder as="span" animation="glow">
                    <Placeholder xs={6} />
                </Placeholder>
            </h2>
            {Array(lines)
                .fill()
                .map((_, i) => (
                    <div className="mb-1">
                        <Placeholder as="span" animation="glow">
                            <Placeholder xs={getRandomNumbe()} />
                        </Placeholder>
                    </div>
                ))}
        </div>
    );
};

export default SkeletonParagraph;